import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomAnchor from "../../../shared/Anchor/CustomAnchor";
import {
  faArrowUpRightFromSquare,
  faStore,
} from "@fortawesome/free-solid-svg-icons";

import "./Header.css";
import "./HeaderResponsive.css";

function Header() {
  return (
    <div className="header-wrapper">
      <div className="video-overlay"></div>
      <video
        preload="auto"
        loop
        muted
        autoPlay
        playsInline
        id="farm-overview"
        onContextMenu={(e) => e.preventDefault()}
      >
        <source
          src={require("../../../assets/videos/background/headerbg.mp4")}
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>

      <div className="header-content-wrapper">
        <div className="header-content">
          <h1>
            <span>FRESH, AFFORDABLE,</span>
            <br />
            <span>
              <span className="highlight-text mr-2">GROWN</span>
              <span>WITH</span>
            </span>
            <br />
            <span className="highlight-text">PURPOSE</span>
          </h1>
          <p>
            Promoting healthy lifestyles through fresh, affordable, and
            nutritious vegetables and herbs. Grown for the health-conscious and
            health-challenged alike.
          </p>
          <div className="d-flex gap-3 mt-5 header-button-actions">
            <CustomAnchor
              path="/shop"
              classname="btn btn-warning header-anchor-buttons shop-button"
            >
              <span>SHOP WITH US</span>
              <FontAwesomeIcon icon={faStore} className="header-anchor-icon" />
            </CustomAnchor>
            <CustomAnchor
              path="/about"
              classname="btn btn-light header-anchor-buttons"
            >
              <span>ABOUT US</span>
              <FontAwesomeIcon
                icon={faArrowUpRightFromSquare}
                className="header-anchor-icon"
              />
            </CustomAnchor>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
